export const AddDistributionModal: string = 'AddDistributionModal';
